export const localStorageKeys = {
  smartAdvisorToken: 'smart-advisor-auth'
};
